const cultures: { value: string, label: string }[] = [
  {
    value: 'es',
    label: 'Español',
  },
]

export default cultures
